import { gridTpl } from '../../../../../common/grid/grid.controller';

export const administrationAccountsEmployeesGrid = {
    bindings: {
        title: '<',
        onSelect: '&'
    },
    controller: 'AdministrationAccountsEmployeesGridController',
    ...gridTpl
};
